module.exports = __webpack_public_path__ + "static/media/icon-cc-small.2eb968da.svg";